'use client';

import React from 'react';
import Footer from '../components/Footer';
import Bottom from './Bottom';
import Header from '../components/Header';
import Introduce from './Introduce';
import Pricing from './Pricing';
import { useGlobalClientContext } from '../common/GlobalClientContext';
import { ProductContextProvider } from '../products/productContext';

export default function PricingPage() {
  const {
    i18nHelper: { t }
  } = useGlobalClientContext();

  return (
      <div className="flex flex-col justify-center w-full bg-base-white">
        <Header />
        <div className="flex flex-col items-center justify-center z-10 mt-[68px] w-[1280px] mx-auto">
          <Introduce />
          <ProductContextProvider>
            <Pricing />
          </ProductContextProvider>
        </div>
        <Bottom />
        <Footer />
      </div>
    );
}
